/**
 * @author Pawan Sadvale
 * @email Pawan.Sadvale@ul.com
 * @create date 2020-04-07 09:21:03
 * @modify date 2020-04-07 09:21:03
 * @desc api services page
 */
import axios from 'axios';

/**
 * login get api
 * to get the autorization token on successful login */
export async function loginUser(formData) {
  let respData = {};
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/login`, formData)
    .then((response) => {
      if (response.data.status && response.headers.authorization) {
        document.cookie = `Authorization = ${response.headers.authorization}; path=/;`;
      }
      respData = response.data;
    })
    .catch((err) => {
      console.log('login java api error', err); // eslint-disable-line no-console
    });
  return respData;
}
/**
 * login_with_account post api
 * to get the autorization token on successful login if user has multiple accounts */
// export async function proceedLogin(formData) {
//   let respData;
//   await axios
//     .post(`${process.env.VUE_APP_PYTHON_API_URL}/login_with_account`, formData)
//     .then((response) => {
//       if (response.data.status && response.headers.access_token) {
//         document.cookie = `Authorization = Bearer ${response.headers.access_token}; path=/;`;
//       }
//       respData = response.data;
//     })
//     .catch((err) => {
//       console.log('login_with_account python api error', err); // eslint-disable-line no-console
//     });
//   return respData;
// }

/**
 * confirm_email get api
 * to get confirm the user account */
export async function confirmLogin(token) {
  let respData = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/confirm_email/${token}`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        respData = response.data;
      }
    })
    .catch((err) => {
      console.log('confirm_email java api error', err); // eslint-disable-line no-console
    });
  return respData;
}

/**
 * * verificationlink post api
* to resend the verficiation link to user */
export async function postVerificationLink(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/verification_link`, data)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('verification_link java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * refresh get api
 * to get the authentication refresh token */
export async function getRefreshToken() {
  let result = false;
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/token/refresh`)
    .then((response) => {
      if (response.data.status_code === 200 && response.headers.authorization) {
        document.cookie = `Authorization = ${response.headers.authorization}; path=/;`;
        result = true;
      }
    })
    .catch((err) => {
      console.log('getRefreshToken java api err', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * switch_account_list
 * to get the mutiple accounts list */
export async function getAccountsList() {
  let result = '';
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/switch_account_list`)
    .then((response) => {
      if (response && response.data.status_code === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('switch_account_list java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * /rbac/service/switchAccount api
 * Switch to selected account */
export async function switchToNewAccount(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/switch_account`, data)
    .then((response) => {
      console.log(response.headers);
      if (response.data.status && response.headers.authorization) {
        document.cookie = `Authorization = ${response.headers.authorization}; path=/;`;
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('switchToNewAccount java api error', err); // eslint-disable-line no-console
    });
  return result;
}
